var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearField(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "clear_field_svg__a",
    d: "M9.104 8.707l2.474 2.475a.75.75 0 01-1.06 1.06L8.043 9.769l-2.475 2.475a.75.75 0 01-1.06-1.061l2.474-2.475-2.475-2.475a.75.75 0 111.061-1.06l2.475 2.474 2.475-2.474a.75.75 0 111.06 1.06L9.104 8.707zm-1.066 7.745a7.75 7.75 0 100-15.5 7.75 7.75 0 000 15.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "clear_field_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#clear_field_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#777",
    xlinkHref: "#clear_field_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#CCC",
    mask: "url(#clear_field_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-4h26v26H-2z"
  })))));
}
export default SvgClearField;